export default "__VITE_ASSET__eAT8VJDU__"